// Сервис для отправки контактных данных с интеграцией Firestore и Google Apps Script
import { saveOrder } from '../firebase/ordersService';

// URL для Google Apps Script (замените на ваш)
const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbzJ-SRwoD0YayXCUL_M7NnLeOn5zET02N77l33Mm1aV4ABVoG2gfuK_ELK_0OG9hKbYqw/exec";

/**
 * Отправляет данные в Google Apps Script
 * @param {Object} data - Данные для отправки
 * @returns {Promise} - Результат отправки
 */
const sendToGoogleScript = async (data) => {
    try {
        // Отправка данных в Google Apps Script

        await fetch(GOOGLE_SCRIPT_URL, {
            method: 'POST',
            mode: 'no-cors', // Важно для Google Apps Script
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        });

        // Данные успешно отправлены в Google Apps Script

        return {
            success: true,
            message: 'Данные отправлены в Google Apps Script'
        };

    } catch (error) {
        throw error;
    }
};

/**
 * Отправляет контактные данные клиента
 * @param {Object} contactData - Данные контакта
 * @param {string} contactData.name - Имя клиента
 * @param {string} contactData.phone - Телефон клиента
 * @param {string} contactData.source - Источник заказа (опционально)
 * @param {string} contactData.language - Язык (опционально)
 * @returns {Promise} - Результат отправки
 */
export const sendContactData = async (contactData) => {
    try {
        // Отправка контактных данных

        // Подготавливаем данные для Firestore
        const orderData = {
            name: contactData.name,
            phone: contactData.phone,
            source: contactData.source || 'website',
            language: contactData.language || 'ru',
            status: 'new',
            // Данные о товаре (если есть)
            productName: contactData.productName || '',
            productPrice: contactData.productPrice || 0,
            productSize: contactData.productSize || '',
            productFeatures: contactData.productFeatures || [],
            productDescription: contactData.productDescription || '',
            // Дополнительные данные
            userAgent: navigator.userAgent,
            referrer: document.referrer,
            timestamp: new Date().toISOString()
        };

        // Сохраняем в Firestore
        const result = await saveOrder(orderData);

        // Заказ успешно сохранен в Firestore

        // Дополнительно отправляем в Google Apps Script в фоне (не ждем)
        sendToGoogleScript(contactData)
            .then(() => {
                // Данные также отправлены в Google Apps Script
            })
            .catch(error => {});

        // Дополнительно сохраняем в localStorage для резервного копирования
        const savedContacts = JSON.parse(localStorage.getItem('ai-son-contacts') || '[]');
        savedContacts.push({
            ...contactData,
            firestoreId: result.orderId,
            timestamp: new Date().toISOString(),
            id: Date.now()
        });
        localStorage.setItem('ai-son-contacts', JSON.stringify(savedContacts));

        return {
            success: true,
            message: 'Данные успешно отправлены',
            orderId: result.orderId
        };

    } catch (error) {

        // Fallback: сохраняем только в localStorage если Firestore недоступен
        try {
            const savedContacts = JSON.parse(localStorage.getItem('ai-son-contacts') || '[]');
            savedContacts.push({
                ...contactData,
                timestamp: new Date().toISOString(),
                id: Date.now(),
                error: 'Firestore недоступен, сохранено локально'
            });
            localStorage.setItem('ai-son-contacts', JSON.stringify(savedContacts));

            // Данные сохранены локально как fallback

            return {
                success: true,
                message: 'Данные сохранены локально (Firestore недоступен)',
                warning: true
            };
        } catch (fallbackError) {
            throw new Error('Не удалось отправить данные');
        }
    }
};

/**
 * Получает сохраненные контакты из localStorage (для разработки)
 * @returns {Array} - Массив сохраненных контактов
 */
export const getSavedContacts = () => {
    try {
        return JSON.parse(localStorage.getItem('ai-son-contacts') || '[]');
    } catch (error) {
        return [];
    }
};

/**
 * Очищает сохраненные контакты (для разработки)
 */
export const clearSavedContacts = () => {
    localStorage.removeItem('ai-son-contacts');
    // Контакты очищены
};
